module.exports = __webpack_public_path__ + "img/11.dfa6d1f6.jpg";